export const pokemonRandomizerContent = {
  introduction: {
    titleKey: "pokemonRandomizer_whatIsItTitle",
    content: [
      `포켓몬 랜덤화기는 예측 불가능성과 흥분의 새로운 물결을 포켓몬 모험에 불어넣도록 설계된 특수 도구입니다. 포켓몬 만남, 아이템 위치, 캐릭터 능력, 심지어 타입 매치업과 같은 다양한 게임 요소를 섞음으로써 포켓몬 랜덤화기 도구는 매번 독특한 게임 플레이 경험을 만들어냅니다. 새로운 도전을 찾는 노련한 트레이너이든, 포켓몬 세계를 탐험할 새로운 방법을 원하는 초보자이든, 저희 랜덤화기는 끝없는 가능성을 제공합니다. 무엇이든 일어날 수 있는 포켓몬 버전에 뛰어들어 완전히 새로운 방식으로 전략적 기술을 시험해보세요!`
    ],
  },
  features: {
    titleKey: "pokemonRandomizer_featuresTitle",
    content: [
      `저희 포켓몬 랜덤화기는 최대한의 재미와 사용자 정의를 위해 설계된 포괄적인 기능 모음으로 두드러집니다. 원하는 대로 랜덤화를 조정하고 섞을 요소를 선택할 수 있습니다. 특정 경로의 야생 포켓몬부터 받는 스타터, 심지어 찾는 아이템까지 제어권은 사용자에게 있습니다. 저희는 원활한 사용자 경험을 우선시하여 포켓몬 랜덤화기가 사용하기 쉽고 빠르며 신선한 포켓몬 여정에 대한 사용자의 욕구와 호환되도록 보장합니다. 고급 옵션을 통해 미세 조정이 가능하여 캐주얼 플레이스루와 너즐록 스타일 챌린지 모두에 완벽한 랜덤화기가 됩니다.`
    ],
  },
  whyUse: {
    titleKey: "pokemonRandomizer_whyUseTitle",
    content: [
      `포켓몬 랜덤화기를 사용하면 고전적인 포켓몬 공식을 활성화하여 놀라운 재생 가능성을 제공합니다. 오래된 습관을 깨고 생각지도 못했던 포켓몬 팀으로 전략을 짜도록 강요합니다. 각 플레이스루는 예상치 못한 만남과 도전으로 가득 찬 독특한 이야기가 됩니다. 콘텐츠 제작자가 매력적인 포켓몬 콘텐츠를 생성하거나 팬이 완전히 새로운 렌즈를 통해 좋아하는 지역을 재발견할 수 있는 훌륭한 방법입니다. 표준 포켓몬 게임 플레이에서 벗어나고 싶다면 랜덤화기는 수많은 시간의 새로운 엔터테인먼트로 가는 관문입니다.`
    ],
  },
  gettingStarted: {
    titleKey: "pokemonRandomizer_gettingStartedTitle",
    content: [
      `저희 도구를 사용하여 첫 포켓몬 랜덤화기 모험을 시작하는 것은 간단합니다! 저희 생성기로 이동하여 만남을 위한 특정 세대, 타입 또는 희귀도 수준과 같은 랜덤화에 필요한 필터를 선택하십시오. 빠른 팀 아이디어를 찾고 있다면 생성할 포켓몬 수를 결정하거나 완전한 랜덤화 플레이스루를 준비하십시오. 저희의 직관적인 인터페이스는 옵션을 안내하여 완벽한 랜덤화 포켓몬 경험을 쉽게 설정할 수 있도록 합니다. '생성'을 클릭하고 랜덤성이 펼쳐지도록 하십시오!`
    ],
  },
  faq: {
    titleKey: "pokemonRandomizer_faqTitle",
    content: [
      `**이 포켓몬 랜덤화기는 무료로 사용할 수 있습니까?** 물론입니다! 저희 도구는 모든 포켓몬 팬에게 완전히 무료입니다.`, 
      `**특정 포켓몬 게임에 이 랜덤화기를 사용할 수 있습니까?** 저희 도구는 모든 세대의 데이터를 기반으로 랜덤 포켓몬을 생성하지만 주로 랜덤 목록이나 팀을 만드는 데 사용됩니다. 게임 내 랜덤화기의 경우 일반적으로 게임 ROM을 수정하는 소프트웨어가 필요합니다. 저희 도구는 영감과 도전 아이디어를 제공합니다.`, 
      `**포켓몬 랜덤화기는 얼마나 무작위적입니까?** 저희는 사용자가 설정한 매개변수 내에서 높은 수준의 무작위성을 보장하기 위해 강력한 알고리즘을 활용하여 진정으로 예측 불가능하고 공정한 경험을 제공합니다.`, 
      `**포켓몬 랜덤화기 설정을 저장할 수 있습니까?** 현재 설정은 단일 세션용이지만 사용자 피드백을 기반으로 항상 새로운 기능을 추가하려고 합니다!`
    ],
  },
};

export default pokemonRandomizerContent; 